import { z } from 'zod';

// Schemas (source of truth) — pure validation, no transforms
export const baseCertificateSchema = z.object({
	name: z.string(),
	groupName: z.string(),
	isCommonlyUsed: z.boolean(),
});

// Types (derived from schemas)
export type IBaseCertificate = z.infer<typeof baseCertificateSchema>;
